import { Badge, IconButton } from "@mui/material";
import { BellAlertOutlined } from "Icons/Icons";
import { INotificationButton } from "./Interfaces";


export const NotificationButton = ({ handleClick, unreadCount }: INotificationButton) => {
  return (
    <IconButton
      onClick={handleClick}
      sx={() => ({
        padding: 1,
      })}
    >
      <Badge badgeContent={unreadCount} color="error" max={99}>
        <BellAlertOutlined />
      </Badge>
    </IconButton>
   
  );
};
